<template>
  <div>
    <h1 v-if="true" class="text-center display-2 my-16 font-weight-bold">✍️ Essays</h1>
    <v-card>
      <v-img height="420px" cover src="/img/projects/essay-self-aware-software-artisan-technology-andromeda-mario-novak.webp"></v-img>
      <v-alert class="" variant="tonal" border-color="purple">
        <h1>
          <a href="https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced">
            Self-Aware Software Artisan
          </a>
        </h1>
        <div class="my-8">
          <v-chip outlined class="mr-2 mb-2">July 29th, 2021</v-chip>
        </div>
        <p class="my-8">
          We are constructing a framework to power individual's continual evolution and meaningful contribution to humanity through Software Development.
        </p>
        <div class="my-8">
          <ol>
            <li>
              <a href="https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced">Intro</a> &nbsp;
              | <strong><a href="https://soundcloud.com/moltouni/self-aware-software-artisan-intro">📣 AUDIO</a></strong>
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/you-a-human-being-self-aware-software-artisan-f7c3641bf422"
                >You - A Human Being</a
              > &nbsp;
              | <strong><a href="https://soundcloud.com/moltouni/you-a-human-being-self-aware-software-artisan">📣 AUDIO</a></strong>
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/health-self-aware-software-artisan-66929c76b240"
                >Your Health</a
              > &nbsp;
              | <strong><a href="https://soundcloud.com/moltouni/your-health-self-aware-software-artisan">📣 AUDIO</a></strong>
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/educating-yourself-self-aware-software-artisan-25e74562c74d"
                >Question Everything</a
              >&nbsp;
              | <strong><a href="https://www.mixcloud.com/moltouni/question-everything-software-artisan-4/">📣
              AUDIO
                  </a></strong>
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/deep-work-self-aware-software-artisan-1c2bdf0dc1dc"
                >Deep work</a
              >
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/joining-existing-software-company-self-aware-software-artisan-38c21c9be12e"
                >Joining a Software Company</a
              >
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/starting-a-software-company-self-aware-software-artisan-34bc562f19f9"
                >Starting a Software Company</a
              >
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/team-self-aware-software-artisan-d765d4641c2e"
                >Team Artisanship</a
              >
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/product-development-self-aware-software-artisan-9b828f601f3b"
                >Product Artisanship</a
              >
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/code-self-aware-software-artisan-6c8712dfc45e"
                >Code Artisanship</a
              >
            </li>
            <li>
              <a
                href="https://medium.com/@moltouni/finishing-up-self-aware-software-artisan-6143d5513395"
                >Finishing up</a
              >
            </li>
          </ol>
        </div>
        <div class="my-8">
          <strong>
            <v-btn
              large
              class="mr-2 mb-2"
              href="https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced"
            >
              <h3>
                Read on Medium
              </h3>
            </v-btn>
          </strong>
          <strong>
            <v-btn
              large
              class="mr-2 mb-2"
              href="https://dev.to/moltouni/self-aware-software-artisan-4ehf"
            >
              <h3>
                Read on Dev.to
              </h3>
            </v-btn>
          </strong>
        </div>
      </v-alert>
    </v-card>
    <v-card class="my-16">
      <v-img height="420px" cover src="/img/projects/essay-progressive-web-development-technology-andromeda-mario-novak.webp"></v-img>
      <v-alert class="" variant="tonal" border-color="purple">
        <h1>
          <a
            href="https://medium.com/@moltouni/web-development-invest-your-time-wisely-d0c260b656d8"
          >
            Progressive Web Development - Invest your time wisely
          </a>
        </h1>
        <div class="my-8">
          <v-chip outlined class="mr-2 mb-2">9 minute read</v-chip>
          <v-chip outlined class="mr-2 mb-2">June 28th, 2020</v-chip>
        </div>
        <p class="my-8">
          Essay is geared towards beginners. <br />
          The goal is to nullify Fear of Missing Out, with respect to all the
          technologies out there,<br />
          and bring clarity and peace to the roadmap you will outline for
          yourself.
        </p>
        <div class="my-8">
          <ol>
            <li>
          Mastering the basics
            </li>
            <li>
          Build as you learn
            </li>
            <li>
          Plan and stick to your roadmap
            </li>
            <li>
          Choosing your technology stack
            </li>
          </ol>
        </div>
        <div class="my-8">
          <h2>
            The Essay got selected and featured by the Medium Curators in the
            Programming topic, on July 2nd, 2020. <br>
            Thank you for reading and sharing.
          </h2>
        </div>
        <div class="my-8">
          <strong>
            <v-btn
              large
              class="mr-2 mb-2"
              href="https://medium.com/@moltouni/web-development-invest-your-time-wisely-d0c260b656d8"
            >
              <h3>
                Read on Medium
              </h3>
            </v-btn>
          </strong>
          <strong>
            <v-btn
              large
              class="mr-2 mb-2"
              href="https://dev.to/moltouni/web-development-invest-your-time-wisely-4mh9"
            >
              <h3>
                Read on Dev.to
              </h3>
            </v-btn>
          </strong>
        </div>
      </v-alert>
    </v-card>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "EssaysComponent",
  components: {
  },
});
</script>
